export const GetSocketConfig = (socketRequest: SocketRequest) => ({
  /**
   * 获取机器当前状态
   */
  getMachineState: () => socketRequest<GetMachineStateResponse>({ service: 'getStates' }),
  /**
   * 获取手诊数据
   */
  getPalpationData: () => socketRequest<GetPalpationDatResponse>({ service: 'getPalpationData' }),
  /**
   * 删除结节
   */
  deleteNodule: (params: DeleteNoduleParams2) => socketRequest<boolean>({ service: 'deleteNodule', params }),
  /**
   * 查询麦克风状态
   */
  getMicrophoneState: () => socketRequest<SwitchState>({ service: 'getMicrophoneState' }),
  /**
   * 设置麦克风状态
   */
  setMicrophone: (params: SwitchState) => socketRequest<string>({ service: 'setMicrophone', params }),
  /**
   * 查询播报模式状态
   */
  getBroadcastState: () => socketRequest<SwitchState>({ service: 'getBroadcastState' }),
  /**
   * 设置播报模式
   */
  setBroadcast: (params: SwitchState) => socketRequest<string>({ service: 'setBroadcast', params }),
  /**
   * 设置背景音乐设置
   */
  setBackgroundMusic: (params: SwitchState) => socketRequest<string>({ service: 'setBackgroundMusic', params }),
  /**
   * 查询音量
   */
  getVolume: () => socketRequest<MachineVolume>({ service: 'getVolume' }),
  /**
   * 设置音量
   */
  setVolume: (params: MachineVolume) => socketRequest<string>({ service: 'setVolume', params }),
  /**
   * 查询力度
   */
  getForce: () => socketRequest<MachineForce>({ service: 'getForce' }),
  /**
   * 设置力度
   */
  setForce: (params: MachineForce) => socketRequest<string>({ service: 'setForce', params }),
  /**
   * 查询高度
   */
  getHeight: () => socketRequest<MachineHeight>({ service: 'getHeight' }),
  /**
   * 设置力度
   */
  setHeight: (params: MachineHeight) =>
    socketRequest<string>({ service: 'setHeight', params }, { errorToastDuration: 5000 }),
  /**
   * 移动
   */
  move: (params: MoveParams) => socketRequest<string>({ service: 'move', params }),
  /**
   * 获取当前任务进度
   */
  getTaskProgress: () => socketRequest<GetTaskProgressResponse>({ service: 'getTaskProgress' }),
  /**
   * 查询冲击波状态
   */
  getShockwaveStates: () => socketRequest<GetShockwaveStatesResponse>({ service: 'getShockwaveStates' }),
  /**
   * 获取冲击波目标状态
   */
  getHitTargetStates: () => socketRequest<GetShockwaveHitTargetInfo>({ service: 'getHitTargetStates' }),
  /**
   * 设置冲击波
   */
  setShockwave: (params: SetShockwaveParams) => socketRequest<string>({ service: 'setShockwave', params }),
  /**
   * 获取射频状态
   */
  getRadioFrequencyStates: () => socketRequest<GetRadioFrequencyStatesResponse>({ service: 'getRadioFrequencyStates' }),
  /**
   * 设置射频
   */
  setRadioFrequency: (params: SetRadioFrequencyParams) =>
    socketRequest<string>({ service: 'setRadioFrequency', params }),
  /**
   * 底盘停驻
   */
  parking: (params: { timeout: number }) => socketRequest<string>({ service: 'parking' }, { timeout: params?.timeout }),
  /**
   * 底盘解锁
   */
  cancelParking: (params: { timeout: number }) =>
    socketRequest<string>({ service: 'cancelParking' }, { timeout: params?.timeout }),
  /**
   * 暂停
   */
  pause: () => socketRequest<string>({ service: 'pause' }),
  /**
   * 继续
   */
  resume: () => socketRequest<string>({ service: 'resume' }),
  /**
   * 开启 RTC
   */
  openRtc: (params: OpenRtcParams) => socketRequest<OpenRtcResponse>({ service: 'openRtc', params }),
  /**
   * 关闭 RTC
   */
  closeRtc: () => socketRequest<string>({ service: 'closeRtc' }),
  /**
   * 开启辅助定位
   */
  openPositionAssistance: (params: OpenRtcParams) =>
    socketRequest<OpenRtcResponse>({ service: 'openPositionAssistance', params }),
  /**
   * 关闭辅助定位
   */
  closePositionAssistance: () => socketRequest<string>({ service: 'closePositionAssistance' }),
  /**
   * 完成按摩头安装
   */
  completeInstallation: () => socketRequest<string>({ service: 'completeInstallation' }),
  /**
   * 确认完成安装线束
   */
  completeWireInstallation: () => socketRequest<string>({ service: 'completeWiring' }),
  /**
   * 跳过按摩步骤
   */
  skip: () => socketRequest<string>({ service: 'skip' }),
  /**
   * 获取当前在第几个按摩步骤
   */
  getMassageAction: () => socketRequest<CommonConfigResponse>({ service: 'getMassageAction' }),
  /**
   * 获取手法
   */
  getMassageTech: () => socketRequest<CommonConfigResponse>({ service: 'getMassageTech' }),
  /**
   * 切换手法
   */
  switchMassageTech: (massageTech: number) =>
    socketRequest<CommonConfigResponse>({ service: 'switchMassageTech', params: { massageTech } }),
  /**
   * 获取速度
   */
  getVelocity: () => socketRequest<MachineVelocity>({ service: 'getVelocity' }),
  /**
   * 调节速度
   */
  switchVelocity: (params: MachineVelocity) => socketRequest<string>({ service: 'switchVelocity', params }),
  /**
   * 获取当前步骤
   */
  getCurrentStep: () => socketRequest<GetCurrentStepResponse>({ service: 'getCurrentStep' }),
  /**
   * 重试人体检测
   */
  retryHumanDetecting: () => socketRequest<string>({ service: 'retryHumanDetecting' }),
  /**
   * 获取矩阵式艾灸区域
   */
  getMoxibustionCompletedAreas: () =>
    socketRequest<GetMoxibustionCompletedAreasResponse>({ service: 'get_moxibustion_completed_areas' }),
  /**
   * 保存结节设置
   */
  setShockwaveNoduleHits: (params: SetShockwaveNoduleHitsParams) =>
    socketRequest<string>({ service: 'set_shockwave_nodule_hits', params }),
  /**
   * 获取当前任务
   */
  getTaskSequenceStatus: () => socketRequest<GetTaskSequenceStatus>({ service: 'getTaskSequenceStatus' }),
  /**
   * 修改背景音乐
   */
  setBackgroundMusicName: (params: SetBackgroundMusicNameParams) =>
    socketRequest<string>({ service: 'setBackgroundMusicName', params }),
  /**
   * 跳过理疗区域检测
   */
  skipBareAreaAbnormal: () => socketRequest<string>({ service: 'skipBareAreaAbnormal' }),
  /**
   * 获取动态渲染actions
   */
  getActions: () => socketRequest<{ actions: Massage.DynamicActionConfig }>({ service: 'getActions' }),
  /**
   * 获取按摩头状态
   */
  getCollisionCheckState: () =>
    socketRequest<GetMoxibustionCheckStateResponse>({ service: 'get_collision_check_state' }),
  /**
   * 执行痛点加强
   */
  executeIntensifyTreatment: () => socketRequest<string>({ service: 'executeIntensifyTreatment' }),
  /**
   * 设置筋膜宝电流强度
   */
  setHotstonePower: (params: SetHotstonePowerParams) => socketRequest<string>({ service: 'setHotstonePower', params }),
  /**
   * 设置筋膜宝温度
   */
  setHotstoneTemperatureLevel: (params: SetHotstoneTemperatureLevelParams) =>
    socketRequest<string>({ service: 'setHotstoneTemperatureLevel', params }),
  /**
   * 筋膜宝切换模式
   */
  switchHotstoneMode: (params: SwitchHotstoneModeParams) =>
    socketRequest<string>({ service: 'switchHotstoneMode', params }),
  /**
   * 获取筋膜宝状态
   */
  getHotstoneStates: () => socketRequest<GetHotstoneStatesResponse>({ service: 'getHotstoneStates' }),
  /**
   * 删除指定ID的自定义画线数据
   */
  deleteCustomRoutes: (params: DeleteCustomRoutesParams) =>
    socketRequest<string>({ service: 'deleteCustomRoutes', params }),
  /**
   * 执行手法轨迹生成
   */
  generateCustomRoutes: () => socketRequest<string>({ service: 'generateCustomRoutes' }),
  /**
   * 调用主程接口关闭视觉画线识别并打开视觉痛点识别
   */
  confirmGeneratedCustomRoutes: () => socketRequest<string>({ service: 'confirmGeneratedCustomRoutes' }),
  /**
   * 重新打开视觉痛点识别
   */
  continueToMarkNodules: () => socketRequest<string>({ service: 'continueToMarkNodules' }),
  /**
   * 进入误差排查
   */
  enterTroubleShoot: () => socketRequest<string>({ service: 'enterTroubleShoot' }),
  /**
   * 完成零漂检查
   */
  completeCheckingDrift: () => socketRequest<string>({ service: 'completeCheckingDrift' }),
  /**
   * 确认安装理疗末端
   */
  completeTroubleShootInstallation: () => socketRequest<string>({ service: 'completeTroubleShootInstallation' }),
  /**
   * 确认完成 Pad 放置
   */
  completeTroubleShootPlacement: () => socketRequest<string>({ service: 'completeTroubleShootPlacement' }),
  /**
   * 退出误差排查
   */
  exitTroubleShoot: () => socketRequest<string>({ service: 'exitTroubleShoot' }),
  /**
   * 获取误差排查状态
   */
  getTroubleShootStates: () => socketRequest<GetTroubleShootStatesResponse>({ service: 'getTroubleShootStates' }),
  /**
   * 坐标上传
   */
  setHandEyePixelCoordinate: (params: SetHandEyePixelCoordinateParams) =>
    socketRequest<string>({ service: 'setHandEyePixelCoordinate', params }),
  /**
   * 将指定 ID 的脊柱标注点删除
   */
  deleteSpinePoints: (params: DeleteSpinePointsParams) =>
    socketRequest<string>({ service: 'deleteSpinePoints', params }),
  /**
   * 将指定 ID 的脊柱标注点删除
   */
  getSpinePoints: () => socketRequest<GetSpinePointsResponse>({ service: 'getSpinePoints' }),
  /**
   * 结束穴位矫正, 开始穴位识别
   */
  finishSpineCalibration: () => socketRequest<string>({ service: 'finishSpineCalibration' }),
  /**
   * 跳过穴位矫正
   */
  skipSpineCalibration: () => socketRequest<string>({ service: 'skipSpineCalibration' }),
  /**
   * 开始沉浸模式按摩头实时位置展示功能
   */
  startRealTimeDisplay: () => socketRequest<string>({ service: 'startRealTimeDisplay' }),
  /**
   * 结束沉浸模式按摩头实时位置展示功能
   */
  endRealTimeDisplay: () => socketRequest<string>({ service: 'endRealTimeDisplay' }),
  /**
   * 沉浸模式实时模式上报爽点
   */
  immerseModeCoolPoint: () => socketRequest<string>({ service: 'immerseModeCoolPoint' }),
});

export const SOCKET_ERR_CODE = {
  0: 'OK',
  10000: '请求错误',
  10001: '禁止操作',
  10002: '服务错误',
  /** @deprecated */
  10003: '密钥错误',
  10004: '执行程序未启动', // 程序错误，非业务错误
  10005: '不支持操作', // 调用当前机器不支持的接口导致，需检查版本
  20000: '操作失败', // 调用机器接口失败
};
